import { message } from "antd";
import axios from "axios";
import { baseURL } from "..";
import { errorActions } from "../helpers/auth_helper";

export async function addClient(values: any) {
  try {
    return await axios
      .post(`${process.env.REACT_APP_API_URL}/client-user/`, {
        ...values,
      })
      .then((response) => {
        if (response.data) {
          message.success("Client added successfully");
          return response.data;
        }
      })
      .catch((error) => {
        errorActions(
          error,
          "Error occurred. Please check if client is already present"
        );
      });
  } catch (error) {}
}

export async function editClient(values: any, id: string) {
  console.log("addCLient", values);
  try {
    await axios
      .put(`${process.env.REACT_APP_API_URL}/client-user/` + id + "/", {
        ...values,
      })
      .then((response) => {
        if (response.data) {
          message.success("Client edited successfully");
          return response.data;
        }
      })
      .catch((error) => {
        errorActions(error, "Error editing client. Please try again");
        return;
      });
  } catch (error) {}
}

const clientsInFlight: { [key: string]: Promise<any> | undefined } = {};

export const fetchClients = async (params: any) => {
  const key = JSON.stringify(params ?? {});
  if (clientsInFlight[key]) {
    return clientsInFlight[key];
  }
  try {
    clientsInFlight[key] = axios
      .get(`${process.env.REACT_APP_API_URL}/client-user/`, {
        ...params,
      })
      .then((res) => {
        if (res) {
          const clients = res?.data;
          return clients;
        }
      })
      .catch((error) => {
        if (error) {
          errorActions(
            error,
            "Error fetching clients. Please check and try again"
          );
          return;
        }
      })
      .finally(() => {
        delete clientsInFlight[key];
      });
    return clientsInFlight[key];
  } catch (error) {}
};

export const fetchClientCart = async (user_id: any) => {
  console.log("data", user_id);

  try {
    const response = await fetch(`${process.env.REACT_APP_API_URL}/sale-cart/?user=` + user_id, {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
    });
    const data = await response.json();
    // console.log("data", data);
    const cart = data;
    return cart;
  } catch (error) {
    message.error("Error fetching client cart. Please check and try again");
    return null;
  }
};

export const fetchClientDetails = async (user_id: any) => {
  console.log("user_id", user_id);
  try {
    return axios
      .get(`${process.env.REACT_APP_API_URL}/client-user/` + user_id)
      .then((res) => {
        const clients = res?.data;
        return clients;
      })
      .catch((e) => {
        errorActions(
          e,
          "Error fetching client details. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

export const fetchClientAddresses = async (user_id: any) => {
  // Always resolves to an array: every caller writes this straight into state and
  // then calls .find/.map on it, so returning undefined on failure crashes them.
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/client-user-address/?user=` +
          user_id
      )
      .then((res) => {
        const address = res?.data;
        return Array.isArray(address) ? address : [];
      })
      .catch((e) => {
        errorActions(
          e,
          "Error fetching client addresses. Please check and try again"
        );
        return [];
      });
  } catch (error) {
    return [];
  }
};

export const editClientAddress = async (address: any, address_id: any) => {
  try {
    return axios
      .put(
        `${process.env.REACT_APP_API_URL}/client-user-address/${address_id}/`,
        {
          ...address,
        }
      )
      .then((res) => {
        if (res.data) {
          message.success("Client address edited successfully");
        }
        const address = res?.data;
        return address;
      })
      .catch((error) => {
        errorActions(error, "Error editing client address. Please try again");
        return;
      });
  } catch (error) {}
};

export const addClientAddress = async (address: any, user_id: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/client-user-address/`, {
        ...address,
        user: user_id,
      })
      .then((res) => {
        if (res.data) {
          message.success("Client address added successfully");
        }
        const address = res?.data;
        return address;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error adding client address. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

export const addClientAlternateContact = async (contact: any, user_id: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/user-alternate/`, {
        ...contact,
        user: user_id,
      })
      .then((res) => {
        if (res.data) {
          message.success("Client alternate contact added successfully");
        }
        const address = res?.data;
        return address;
      })
      .catch((error) => {
        errorActions(
          error,
          "Error adding client alternate contact. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

export async function editClientAlternateContact(values: any, id: string) {
  try {
    await axios
      .put(`${process.env.REACT_APP_API_URL}/user-alternate/` + id + "/", {
        ...values,
      })
      .then((response) => {
        if (response.data) {
          message.success("Client alternate successfully");
          return response.data;
        }
      })
      .catch((error) => {
        errorActions(error, "Error editing client. Please try again");
        return;
      });
  } catch (error) {}
}

export const fetchClientAlternateContact = async (user_id: any) => {
  try {
    return axios
      .get(
        `${process.env.REACT_APP_API_URL}/user-alternate/?user=` +
          user_id
      )
      .then((res) => {
        if (res) {
          const contacts = res?.data;
          return contacts;
        }
      })
      .catch((e) => {
        errorActions(
          e,
          "Error fetching client addresses. Please check and try again"
        );
        return;
      });
  } catch (error) {}
};

const lastTenDigits = (phone: any) => String(phone ?? "").replace(/\D/g, "").slice(-10);

export const resolveClientAlternative = async (
  user_id: any,
  name: string,
  phone: string
): Promise<number | null> => {
  const target = lastTenDigits(phone);
  if (!user_id || target.length !== 10) return null;

  const client = await fetchClientDetails(user_id);
  if (lastTenDigits(client?.contact) === target) return null;

  const existing = await fetchClientAlternateContact(user_id);
  const match = (existing || []).find(
    (alt: any) => lastTenDigits(alt?.contact_person_contact) === target
  );
  if (match) return match.id;

  const created = await addClientAlternateContact(
    { contact_person_name: name, contact_person_contact: target },
    user_id
  );
  return created?.id ?? null;
};

export const checkPhoneExists = async (phone: string): Promise<boolean> => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/check-phone-exists/?phone=${encodeURIComponent(phone)}`
    );
    return res.data.exists ?? false;
  } catch (error) {
    return false;
  }
};

export const addClientDocuments = async (formData: any) => {
  try {
    return axios
      .post(`${process.env.REACT_APP_API_URL}/project-files/`, formData)
      .then((res) => {
        if (res.data) {
          message.success("Client Documents added successfully");
        }
        return {
          document: res?.data?.file,
          id: res?.data?.id,
          file_name: res?.data?.file_name,
        };
      })
      .catch((e) => {
        errorActions(e, "Error adding client documents. Please try again");
        return;
      });
  } catch (error) {}
};

export const bookSlot = async (data: {
  name: string;
  contact: string;
  date?: string;
  email?: string;
}) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_URL}/book-slot/`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `JWT ${localStorage.getItem("token")}`,
      },
      method: "POST",
      body: JSON.stringify(data),
    }
  );

  return await response.json();
};

export const editSlot = async (data: { [key: string]: unknown }) => {
  if (!data?.id) return;

  return axios
    .put(`${process.env.REACT_APP_API_URL}/book-a-slot/` + data.id, data)
    .then((res) => {
      if (res.data) {
        message.success("Appointment updated successfully");
      }
      return res.data;
    })
    .catch((e) => {
      errorActions(e, "Error updating appointment. Please try again");
      return;
    });
};

export const cancelSlot = async (booking_number: string) => {
  if (!booking_number) return;

  return axios
    .get(`${process.env.REACT_APP_API_URL}/cancel-slot/`, {
      params: {
        booking_number,
        send_message: "True",
      },
    })
    .then((res) => {
      if (res.data) {
        message.success("Appointment cancelled successfully");
      }
      return res.data;
    })
    .catch((e) => {
      errorActions(e, "Error updating appointment. Please try again");
      return;
    });
};

export const getUserCartCount = async (
  params: Record<string, string | number>
) => {
  return axios
    .get(`${process.env.REACT_APP_API_URL}/user-cart-count/`, {
      params,
    })
    .then((res) => res.data)
    .catch((e) => {
      errorActions(e, "Error fetching cart count. Please try again");
      return;
    });
};

export const createFootfallRecord = async (data: {
  name: string;
  contact: number;
  source: string;
  pov: string;
}) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/footfall-record/`, data)
    .then((res) => {
      if (res.data) {
        message.success("Footfall record created successfully");
      }
      return res.data;
    })
    .catch((e) => {
      console.log(e);
      errorActions(e, "Error creating footfall record. Please try again");
      return;
    });
};

export async function assignClientBM(
  client_id: string,
  manager_organisation_id: string | number,
  role: string | number
) {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_URL}/user-manager-assignment/`,
      {
        user: client_id,
        manager: manager_organisation_id,
        role: role,
        status: "true",
      }
    );

    return response.data;
  } catch (error) {
    errorActions(
      error as any,
      "Error assigning client to BM. Please try again"
    );
  }
}

export async function clientBMCartsV2({
  page = 1,
  ordering = "-lead_time_updated_at",
  search,
  all_lead_time_filled,
  user_organisation,
  skip_bm_filter,
  cart_value__gte,
  last_modified_after,
  last_modified_before,
}: {
  page?: number;
  ordering?: string;
  all_lead_time_filled?: boolean;
  search?: string;
  user_organisation?: string | number;
  skip_bm_filter?: boolean;
  cart_value__gte?: number;
  last_modified_after?: string;
  last_modified_before?: string;
}) {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/bm-carts-v2/`,
      {
        params: {
          page,
          ordering,
          search,
          all_lead_time_filled,
          user_organisation,
          skip_bm_filter,
          cart_value__gte,
          last_modified_after,
          last_modified_before,
        },
      }
    );

    return response.data;
  } catch (e) {
    return null;
  }
}

// Single-use coupons a BM issues to one client from the client-details page.
export interface ClientCoupon {
  user_coupon_id: number;
  coupon_id: number;
  coupon_code: string;
  type: "percentage" | "value";
  coupon_value: number;
  upto_value: number;
  min_cart_value: number;
  cumulative_sum_above: number;
  is_free_delivery: boolean;
  valid_till: string;
  description: string | null;
  created_at: string;
  status: "active" | "used" | "expired" | "inactive";
}

export interface CreateClientCouponBody {
  user_id: string;
  coupon_code: string;
  type: "percentage" | "value";
  coupon_value: number;
  upto_value?: number;
  min_cart_value?: number;
  cumulative_sum_above?: number;
  is_free_delivery?: boolean;
  valid_till: string; // YYYY-MM-DD
  description?: string;
  // Copies area codes, T&C, max cart value and free delivery from this coupon
  // (server-side). Scope is sent explicitly below.
  template_coupon_id?: number;
  // Scope: excluded + empty = no restriction; excluded + ids = all except;
  // not excluded = only these.
  is_brand_excluded?: boolean;
  brand_ids?: number[];
  is_category_excluded?: boolean;
  category_ids?: number[];
  is_variant_excluded?: boolean;
  variant_ids?: number[];
}

export const fetchClientCoupons = async (
  user_id: string
): Promise<{ data: ClientCoupon[]; can_create: boolean }> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/user/`, {
      params: { user_id },
    });
    return { data: res?.data?.data ?? [], can_create: !!res?.data?.can_create };
  } catch (error: any) {
    errorActions(error, "Error fetching client coupons. Please try again");
    return { data: [], can_create: false };
  }
};

// Rejects on failure so the modal can show the backend's reason (duplicate code, 403, ...).
export const createClientCoupon = (body: CreateClientCouponBody) =>
  axios.post(`${process.env.REACT_APP_API_URL}/coupon/create/`, body);

// General coupons — any customer can use them, any number of times — managed from
// Organisation → Coupons. Gated by the coupon.read/create/update/delete permissions.
export interface GeneralCoupon {
  coupon_id: number;
  coupon_code: string;
  type: "percentage" | "value";
  coupon_value: number;
  upto_value: number;
  min_cart_value: number;
  cumulative_sum_above: number;
  is_free_delivery: boolean;
  valid_till: string;
  description: string | null;
  is_hidden: boolean;
  is_active: boolean;
  times_used: number;
  can_delete: boolean; // false once any PI carries it — disable instead
  created_at: string;
  status: "active" | "expired" | "inactive";
}

export type CreateGeneralCouponBody = Omit<CreateClientCouponBody, "user_id"> & {
  is_hidden?: boolean;
};

export const fetchGeneralCoupons = async (): Promise<{ data: GeneralCoupon[] }> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/general/`);
    return { data: res?.data?.data ?? [] };
  } catch (error: any) {
    errorActions(error, "Error fetching coupons. Please try again");
    return { data: [] };
  }
};

// Rejects on failure so the modal can show the backend's reason (duplicate code, 403, ...).
export const createGeneralCoupon = (body: CreateGeneralCouponBody) =>
  axios.post(`${process.env.REACT_APP_API_URL}/coupon/general/`, body);

// Both reject on failure so the caller can show the backend's reason (403, 409 "used", ...).
export const updateGeneralCoupon = (coupon_id: number, body: CreateGeneralCouponBody) =>
  axios.put(`${process.env.REACT_APP_API_URL}/coupon/general/`, body, { params: { coupon_id } });

export const setGeneralCouponActive = (coupon_id: number, is_active: boolean) =>
  axios.patch(`${process.env.REACT_APP_API_URL}/coupon/general/`, { is_active }, {
    params: { coupon_id },
  });

export const deleteGeneralCoupon = (coupon_id: number) =>
  axios.delete(`${process.env.REACT_APP_API_URL}/coupon/general/`, {
    params: { coupon_id },
  });

// "Copy settings from" in the create-coupon modal: any existing coupon can be a template.
export interface CouponTemplateOption {
  coupon_id: number;
  coupon_code: string;
  type: "percentage" | "value";
  coupon_value: number;
  upto_value: number;
  is_user_restricted: boolean;
  status: "active" | "expired" | "inactive";
  brand_count: number;
  variant_count: number;
  category_count: number;
}

export interface CouponTemplateDetail {
  coupon_id: number;
  coupon_code: string;
  status: "active" | "expired" | "inactive";
  is_user_restricted: boolean;
  type: "percentage" | "value";
  coupon_value: number;
  upto_value: number;
  min_cart_value: number;
  cumulative_sum_above: number;
  description: string;
  is_hidden: boolean;
  valid_till: string;
  max_cart_value: number;
  is_free_delivery: boolean;
  area_codes: string[];
  terms_and_conditions: string;
  is_brand_excluded: boolean;
  brands: { id: number; name: string | null }[];
  is_variant_excluded: boolean;
  variants: { id: number; name: string; handle: string }[];
  is_category_excluded: boolean;
  categories: { id: number; name: string | null }[];
}

export const searchCouponTemplates = async (q: string): Promise<CouponTemplateOption[]> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/templates/`, {
      params: { q },
    });
    return res?.data?.data ?? [];
  } catch (error: any) {
    errorActions(error, "Error searching coupons. Please try again");
    return [];
  }
};

export const fetchCouponTemplate = async (
  coupon_id: number
): Promise<CouponTemplateDetail | null> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/templates/`, {
      params: { coupon_id },
    });
    return res?.data?.data ?? null;
  } catch (error: any) {
    errorActions(error, "Error loading coupon. Please try again");
    return null;
  }
};

export interface CouponScopeOption {
  id: number;
  name: string;
}

export const searchCouponScopeOptions = async (
  kind: "brand" | "category",
  q: string
): Promise<CouponScopeOption[]> => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_API_URL}/coupon/scope-options/`, {
      params: { kind, q },
    });
    return res?.data?.data ?? [];
  } catch (error: any) {
    errorActions(error, `Error searching ${kind === "brand" ? "brands" : "categories"}`);
    return [];
  }
};

export interface CouponVariantRef {
  id: number;
  name: string;
  handle: string;
}

// Rejects on failure so the caller can show the backend's reason.
export const resolveCouponVariants = async (
  refs: string
): Promise<{ found: CouponVariantRef[]; not_found: string[] }> => {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/coupon/variants/resolve/`, {
    refs,
  });
  return res.data.data;
};
